import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image/index.js';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 50px 0;

  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.neutral_1')};

  h1,
  h2,
  h3 {
    margin-bottom: 30px;
  }

  ul {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    li {
      list-style-type: none;

      margin: 10px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &.Wide {
    padding: 50px 0 60px;

    ul {
      display: flex;
      align-items: stretch;
      width: 100%;
      margin: 0;

      padding: 0 90px;
    }

    li {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;

      margin: 30px 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.Narrow {
    padding: 50px 0 60px;
    ul {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      width: 100%;
      margin: 0;
    }

    li {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 20%;

      max-width: 82px;
      margin: 0 16.75px;

      &:first-child,
      &:last-child {
        margin: 0 16.75px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 0 60px;
    ul {
      li {
        margin: 20px;
      }
    }

    &.Wide {
      padding: 70px 0 90px;

      ul {
        display: flex;
        justify-content: center;
        align-items: stretch;
        width: 100%;
        margin: 0;
      }

      li {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 20%;

        max-width: 225px;
        margin: 30px;

        &:first-child,
        &:last-child {
          margin: 0 16.75px;
        }
      }
    }

    &.Narrow {
      padding: 50px 0 60px;
      li {
        margin: 0 33.5px;

        &:first-child,
        &:last-child {
          margin: 0 33.5px;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 60px 0;

    &.Wide {
      padding: 70px 0 90px;
      ul {
        display: flex;
        align-items: stretch;
        width: 100%;
        margin: 0;
        padding: 0;
      }

      li {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 20%;

        max-width: 225px;
        max-height: 103px;
        margin: 30px 90px;

        &:first-child,
        &:last-child {
          margin: 30px 16.75px 00px;
        }
        &:last-child {
          margin: 30px 16.75px;
        }
      }
    }

    &.Narrow {
      padding: 70px 0 90px;
      li {
        max-width: 147px;
      }
    }

    h1,
    h2,
    h3 {
      margin-bottom: 30px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    &.Wide {
      li {
        margin: 30px 20px;

        &:first-child,
        &:last-child {
          margin: 30px 16.75px 00px;
        }
        &:last-child {
          margin: 30px 16.75px;
        }
      }
    }
  }
`;

// * Styling for each award (Sizing)
export const AwardImage = styled(Image)`
  max-width: 225px;
  max-height: 103px;

  ${Wrapper}.wide &, ${Wrapper}.Wide & {
    height: auto;
    width: 100%;
    margin: auto;
  }

  ${Wrapper}.narrow &, ${Wrapper}.Narrow & {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: 100%;
    margin: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 150px;
    max-height: 70px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 225px;
    max-height: 103px;
  }
`;
